import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router';
import { useRefreshShell, useShell } from '@/context/shell-context';
import { useTriggerOptIn } from '@hooks/register/use-trigger-opt-in';
import { useSession } from '@hooks/security/use-session';
import { useLocalize } from '@hooks/use-localize';

const TriggerOptIn = () => {
    const { registrationId, editKey } = useSession();
    const { trigger, error } = useTriggerOptIn(registrationId, editKey);
    const t = useLocalize(useShell().languageData);
    const refreshShell = useRefreshShell();

    const hasTriggered = useRef(false);
    const [isOptedIn, setIsOptedIn] = useState(false);

    useEffect(() => {
        if (hasTriggered.current) return;

        hasTriggered.current = true;

        trigger().then((result) => {
            setIsOptedIn(result.ok);

            if (result.ok) refreshShell();
        });
    }, [trigger, refreshShell]);

    if (error) {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12">
                        <div className="alert alert-danger">{error}</div>
                    </div>
                </div>
            </div>
        );
    }

    // BusyOverlay covers the wait.
    if (!isOptedIn) return null;

    return (
        <div className="container-fluid">
            <div className="row row-margined">
                <div className="col-xs-12 col-sm-7 col-sm-offset-0">
                    <div className="row row-margined">
                        <div className="col-xs-12">
                            <h1>{t('DashLabel_ThankYou', 'Thank You')}</h1>
                            <p>Thank you for your response. Your request has been noted, and we will have someone reach out to you within the next 48 hours.</p>
                        </div>
                    </div>

                    <div className="row row-margined">
                        <div className="col-xs-12">
                            <Link className="btn btn-primary" to="/register/donate">
                                {t('DashLabel_BackToDashboard', 'Back to Dashboard')}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TriggerOptIn;
